module.exports = __webpack_public_path__ + "media/images/alee-sm-68e486b867381201265bf0b2b330266c.jpg";